"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ChildrenNode_1 = require("./snap/ChildrenNode");
/**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 *
 * @constructor
 */
var SnapshotHolder = /** @class */ (function () {
 function SnapshotHolder() {
 this.rootNode_ = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
 }
 SnapshotHolder.prototype.getNode = function (path) {
 return this.rootNode_.getChild(path);
 };
 SnapshotHolder.prototype.updateSnapshot = function (path, newSnapshotNode) {
 this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
 };
 return SnapshotHolder;
}());
exports.SnapshotHolder = SnapshotHolder;

//# sourceMappingURL=SnapshotHolder.js.map



//////////////////
// WEBPACK FOOTER
// ../database/dist/cjs/src/core/SnapshotHolder.js
// module id = 97
// module chunks = 0